<template>
  <back-office-list
    :title="this.$t('common.games')"
    :has-add-button="true"
    :add-button-caption="this.$t('games.add')"
    :loading="gamesMeta.loading"
    :list-data="games"
    route-to-add-page="add-game"
    :selection-change="handleSelectionChange"
  />
</template>

<script>
  import {gameService} from "@/services";
  import { useQuery } from "codefabrik-gui-vue/src/apollo";
  import BackOfficeList from "@/components/BackOfficeList";

  export default {
    name: 'Games',
    components: {BackOfficeList},
    mixins: [
      useQuery({
        name: 'games',
        serviceFn: gameService.getGames,
        mappingFunctions: {
          games: [(gamePage) => gamePage.game, () => []]
        }
      })
    ],
    methods: {
      handleSelectionChange(game) {
        this.$router.push({name: 'edit-game', params: {id: game.id}})
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
